import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { StepsCounter } from './components/StepsCounter/StepsCounter';
import { StepDisplay } from './components/StepDisplay/StepDisplay';
import { Footer } from './components/Footer/Footer';

import { isFullFilledZone } from './slices/humidityZone/humidityZoneSelectors';
import { isFullFilledHumidityRoom } from './slices/humidityRoom/humidityRoomSelectors';
import { isFullFilledBrand } from './slices/brand/brandSelectors';
import { isFullFilledWalls } from './slices/WallsCharacteristics/WallsCharacteristicsSelectors';

// import { useGetParcedCsvData } from './custom-hooks/useGetParcedCsvData';
// import { prepareDataHelper } from './helpers/prepareDataHelper';

import { useGetJsonData } from './custom-hooks/useGetJsonData';

import { setHumidityZone } from './slices/humidityZone/humidityZoneSlice';

import { resetBrand } from './slices/brand/brandSlice';
import { resetHumidityRoom } from './slices/humidityRoom/humidityRoomSlice';
import { resetHumidityZone } from './slices/humidityZone/humidityZoneSlice';
import { resetWallsCharacteristics } from './slices/WallsCharacteristics/WallsCharacteristicsSlice';

import { stepData } from './data/step-data'

import './App.css';

function App() {
  const dispatch = useDispatch();

  // const humidityZone = useGetParcedCsvData('humidity-zone.csv');
  // const humidityZone2 = useGetJsonData('humidity-zone.json');
  
  // const humidityPreparedData = useMemo(() => prepareDataHelper(humidityZone?.data.slice(1)), [humidityZone]);
  const humidityPreparedData = useGetJsonData('humidity-zone.json');

  useEffect(()=>{
    dispatch(setHumidityZone(humidityPreparedData || {}));
  }, [humidityPreparedData, dispatch])

  // console.log('humidityZone2', humidityZone2);
  // console.log('humidityZone', humidityZone);


  const [curStep, setCurStep] = useState(0);
  const [isFinalStep, setIsFinalStep] = useState(false);
  const [isWasCalculated, setIsWasCalculated] = useState(false);
  const [isFilledStep, setIsFilledStep] = useState(false);

  const isFilledZone = useSelector(isFullFilledZone);
  const isFilledRoom = useSelector(isFullFilledHumidityRoom);
  const isFilledBrand = useSelector(isFullFilledBrand);
  const isFilledWalls = useSelector(isFullFilledWalls);
  
  useEffect(()=> {
    if(curStep === stepData.length -1) {
      setIsFinalStep(true);
    } else if(curStep > stepData.length -1) {
      setIsWasCalculated(true)
    } else {
      setIsFinalStep(false);
      setIsWasCalculated(false)
    }
  }, [curStep])

  const changeStep = (direction) => {
    setCurStep(prevStep => prevStep + direction);
  }

  const resetStep = () => {
    dispatch(resetBrand());
    dispatch(resetHumidityRoom());
    dispatch(resetHumidityZone());
    dispatch(resetWallsCharacteristics());
    setCurStep(0);
  }

  useEffect(()=> {
    switch (curStep) {
      case 0:
        setIsFilledStep(isFilledZone);
        break;
      case 1: 
        setIsFilledStep(isFilledRoom);
        break;
      case 2:
        setIsFilledStep(isFilledWalls);
        break;
      case 3:
        setIsFilledStep(isFilledBrand);
        break;
      default:
        setIsFilledStep(false);
        break;
    }
  }, [curStep, isFilledZone, isFilledRoom, isFilledWalls, isFilledBrand ])


  return (
    <div className="app">
      <main className="app__main">
        <div className="app__steps">
          <StepsCounter curStep={curStep} stepData={stepData} />
        </div>
        <div className="app__main">
          <StepDisplay curStep={curStep} />
        </div>
        <div className="app__footer">
          <Footer 
            changeStepHandler={changeStep} 
            resetHandler={resetStep} 
            curStep={curStep} 
            isFinalStep={isFinalStep}
            isWasCalculated={isWasCalculated}
            isFilledStep={isFilledStep}
          />
        </div>
      </main>
    </div>
  );
}

export default App;
